import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacFieldComponent,
  CacImageUploaderComponent,
} from '@controladad/ng-base';
import { of } from 'rxjs';
import { formControl, formGroup, Validators } from '@al00x/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { UploadResult } from '../../../services';
import { OrderedProductImage } from '@models';

@Component({
  selector: 'lib-upload-image-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CacDialogLayoutComponent, CacImageUploaderComponent, ReactiveFormsModule, CacFieldComponent],
  templateUrl: 'product-image-upload-dialog.component.html',
})
export class UploadImageDialogComponent extends CacBaseDialogComponent<undefined, OrderedProductImage | null> {
  formGroup = formGroup({
    image: formControl<UploadResult>(undefined, Validators.required),
    order: formControl<number>(1),
  });

  onSubmit() {
    const values = this.formGroup.getRawValue();

    return this.submit({
      url: values.image.imageUrl,
      path: values.image.imagePath,
      order: values.order,
    });
  }
}
